import React from "react";
import styled from "styled-components";
import Fav from "./Card-Elements/Fav";
import CardTitle from "./Card-Elements/CardTitle";
import CardImg from "./Card-Elements/CardImg";
import ResponsiveCardImg from "./Card-Elements/ResponsiveCardImg";
import CardBody from "./Card-Elements/CardBody";
import CardUtils from "./Card-Elements/CardUtils";
import CardUpperText from "./Card-Elements/CardUpperText";
import CardText from "./Card-Elements/CardText";
import CardPrice from "./Card-Elements/CardPrice";
const Wrapper = styled.div`
  width: clamp(220px, 24vw, 470px);
  height: clamp(400px, 45vw, 800px);
  cursor: pointer;
  position: relative;
  @media (max-width: 767px) {
    width: 210px;
    height: 372px;
  }
  img {
    transition: ease-out 0.7s !important;
  }
  &:hover {
    img {
      transform: scale(1.06);
    }
  }
`;

function Card({ children }) {
  return (
    <>
      <Wrapper>{children}</Wrapper>
    </>
  );
}

/** @component */
export default Object.assign(Card, {
  Header: Fav,
  Title: CardTitle,
  Img: CardImg,
  ResponsiveImg: ResponsiveCardImg,
  Body: CardBody,
  Utils: CardUtils,
  Text: CardText,
  UpperText: CardUpperText,
  Price: CardPrice,
});
